import React from "react";

function RadioButton(props) {
  // Value already taken by a linked question (e.g. the first interest), which
  // this group must not repeat.
  let takenValue = props.item.mustDifferFrom
    ? props.data[props.item.mustDifferFrom]
    : null;

  let handleChange = (e) => {
    let value = e.target.value;
    props.onChange && props.onChange(e);

    // Clear any linked field that would now hold the same value, in both the
    // shared form data and react-hook-form's own state.
    let cleared = {};
    (props.item.clearOnConflict || []).forEach((field) => {
      if (props.data[field] === value) {
        cleared[field] = "";
        props.setValue && props.setValue(field, "", { shouldValidate: true });
      }
    });

    props.setData({
      ...props.data,
      ...cleared,
      [props.name]: value,
    });
  };

  return (
    <div className="radioSection">
      {props.item.options.map((option, i) => {
        let isTaken = takenValue === option;

        return (
          <label key={i} className={isTaken ? "radioItemDisabled" : undefined}>
            <input
              className="radioItemInput"
              type="radio"
              name={props.name}
              value={option}
              disabled={isTaken}
              checked={props.data[props.name] === option}
              onChange={handleChange}
            />
            <span className="radioItemLabel">
              {option}
              {isTaken && ` ${props.item.mustDifferHint || "(already chosen)"}`}
            </span>
          </label>
        );
      })}
    </div>
  );
}

export default RadioButton;
